import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SelectTree',
  // 设置绑定参数
  model: {
    prop: 'value',
    event: 'selected'
  },
  props: {
    // 控制是否单选
    singleChoose: {
      type: Boolean,
      default: false
    },
    // 接收绑定参数
    value: [String, Array],
    // 输入框宽度
    width: String,
    // 是否可用
    disabled: {
      type: Boolean,
      default: false
    },
    // 选项数据
    options: {
      type: Array,
      required: true
    },
    // 输入框占位符
    placeholder: {
      type: String,
      required: false,
      default: '请选择'
    },
    // 树节点配置选项
    props: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          parent: 'parentId',
          value: 'rowGuid',
          label: 'areaName',
          children: 'children'
        };
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    checkStrictly: Boolean,
    checkOnClickNode: Boolean,
    defaultExpandedKeys: Array
  },
  data: function data() {
    return {
      // 树状菜单显示状态
      showStatus: false,
      // 菜单宽度
      treeWidth: 'auto',
      // 输入框显示值
      labelModel: '',
      // 实际请求传值
      valueModel: '',
      inputHovering: false
    };
  },
  computed: {
    // 是否为树状结构数据
    dataType: function dataType() {
      var jsonStr = JSON.stringify(this.options);
      return jsonStr.indexOf(this.props.children) !== -1;
    },
    // 若非树状结构，则转化为树状结构数据
    data: function data() {
      return this.dataType ? this.options : this.switchTree();
    },
    showClose: function showClose() {
      var hasValue = this.showCheckbox ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
      return !this.disabled && this.inputHovering && hasValue;
    },
    iconClass: function iconClass() {
      console.log(this.showStatus);
      return this.showStatus ? 'arrow-up is-reverse' : 'arrow-up';
    }
  },
  watch: {
    labelModel: function labelModel(val) {
      var _this = this;
      if (val && this.showCheckbox) {
        this.valueModel = [];
        var checkedNodes = this.$refs.tree.getCheckedNodes();
        if (checkedNodes) {
          checkedNodes.forEach(function (data) {
            _this.valueModel.push(data[_this.props.value]);
          });
        }
        return;
      }
      if (!val) {
        this.valueModel = '';
      }
      this.$refs.tree.filter(val);
    },
    value: function value(val) {
      var _this2 = this;
      if (val && val instanceof Array) {
        var label = '';
        val.forEach(function (v) {
          label += _this2.queryTree(_this2.data, v) + ',';
        });
        this.labelModel = label.substr(0, label.length - 1);
      } else {
        if (val && val.indexOf(',') > -1) {
          var valArray = val.split(',');
          var _label = '';
          valArray.forEach(function (v) {
            _label += _this2.queryTree(_this2.data, v) + ',';
          });
          this.labelModel = _label.substr(0, _label.length - 1);
        } else {
          this.labelModel = this.queryTree(this.data, val);
        }
      }
    },
    options: function options() {
      var _this3 = this;
      // 检测输入框原有值并显示对应 label
      if (this.value) {
        if (this.value && this.showCheckbox && this.$refs.tree) {
          this.$refs.tree.setCheckedKeys(this.value instanceof Array ? this.value : this.value.split(','));
        }
        if (this.value instanceof Array) {
          var label = '';
          this.value.forEach(function (v) {
            label += _this3.queryTree(_this3.data, v) + ',';
          });
          this.labelModel = label.substr(0, label.length - 1);
        } else {
          if (this.value.indexOf(',') > -1) {
            var valArray = this.value.split(',');
            var _label2 = '';
            valArray.forEach(function (v) {
              _label2 += _this3.queryTree(_this3.data, v) + ',';
            });
            this.labelModel = _label2.substr(0, _label2.length - 1);
          } else {
            this.labelModel = this.queryTree(this.data, this.value);
          }
        }
      }
    }
  },
  created: function created() {
    var _this4 = this;
    // 检测输入框原有值并显示对应 label
    if (this.value) {
      if (this.value instanceof Array) {
        var label = '';
        this.value.forEach(function (v) {
          label += _this4.queryTree(_this4.data, v) + ',';
        });
        this.labelModel = label.substr(0, label.length - 1);
      } else {
        if (this.value.indexOf(',') > -1) {
          var valArray = this.value.split(',');
          var _label3 = '';
          valArray.forEach(function (v) {
            _label3 += _this4.queryTree(_this4.data, v) + ',';
          });
          this.labelModel = _label3.substr(0, _label3.length - 1);
        } else {
          this.labelModel = this.queryTree(this.data, this.value);
          this.valueModel = this.value;
        }
      }
    }
    // 获取输入框宽度同步至树状菜单宽度
    this.$nextTick(function () {
      _this4.treeWidth = "".concat((_this4.width || _this4.$refs.input.$refs.input.clientWidth) - 24, "px");
    });
  },
  methods: {
    // 选择框
    onCheckNode: function onCheckNode(data, checked, node) {
      var _this5 = this;
      // 控制是否单选
      if (checked && this.singleChoose) {
        this.$refs.tree.setCheckedNodes([data]);
      }
      if (this.showCheckbox) {
        var checkedNodes = this.$refs.tree.getCheckedNodes();
        this.labelModel = '';
        this.valueModel = [];
        if (checkedNodes) {
          checkedNodes.forEach(function (data) {
            _this5.labelModel += data[_this5.props.label] + ',';
            _this5.valueModel.push(data[_this5.props.value]);
          });
          this.labelModel = this.labelModel.substr(0, this.labelModel.length - 1);
        }
        this.$emit('selected', this.valueModel);
      }
    },
    // 单击节点
    onClickNode: function onClickNode(data) {
      if (!this.showCheckbox) {
        this.labelModel = data[this.props.label];
        this.valueModel = data[this.props.value];
        this.onCloseTree();
      }
    },
    // 偏平数组转化为树状层级结构
    switchTree: function switchTree() {
      // 根节点默认值变更 By ZhaiCY Start
      // return this.cleanChildren(this.buildTree(this.options, '0))
      return this.cleanChildren(this.buildTree(this.options, null));
      // 根节点默认值变更 By ZhaiCY End.
    },
    // 隐藏树状菜单
    onCloseTree: function onCloseTree() {
      this.$refs.popover.showPopper = false;
    },
    // 显示时触发
    onShowPopover: function onShowPopover() {
      this.showStatus = true;
      this.$refs.tree.filter(false);
    },
    // 隐藏时触发
    onHidePopover: function onHidePopover() {
      var _this6 = this;
      if (this.showCheckbox) {
        var checkedNodes = this.$refs.tree.getCheckedNodes();
        this.labelModel = '';
        this.valueModel = [];
        if (checkedNodes) {
          checkedNodes.forEach(function (data) {
            _this6.labelModel += data[_this6.props.label] + ',';
            _this6.valueModel.push(data[_this6.props.value]);
          });
          this.labelModel = this.labelModel.substr(0, this.labelModel.length - 1);
        }
      }
      this.showStatus = false;
      this.$emit('selected', this.valueModel);
    },
    // 树节点过滤方法
    filterNode: function filterNode(query, data) {
      if (!query) return true;
      return data[this.props.label].indexOf(query) !== -1;
    },
    // 查询树状数据中的 ID
    queryTree: function queryTree(tree, id) {
      var stark = [];
      stark = stark.concat(tree);
      while (stark.length) {
        var temp = stark.shift();
        if (temp[this.dataType ? this.props.children : 'children']) {
          stark = stark.concat(temp[this.dataType ? this.props.children : 'children']);
        }
        if (temp[this.props.value] === id) {
          return temp[this.props.label];
        }
      }
      return '';
    },
    // 将一维的扁平数组转换为多层级对象
    buildTree: function buildTree(data) {
      var _this7 = this;
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
      var _fa = function fa(parentId) {
        var temp = [];
        for (var i = 0; i < data.length; i++) {
          var n = data[i];
          if (n[_this7.props.parent] === parentId) {
            // Bug修正 By ZhaiCY Start
            // n.children = fa(n.rowGuid)
            n.children = _fa(n[_this7.props.value]);
            // Bug修正 By ZhaiCY End.
            temp.push(n);
          }
        }
        return temp;
      };
      return _fa(id);
    },
    // 清除空 children项
    cleanChildren: function cleanChildren(data) {
      var _fa2 = function fa(list) {
        list.map(function (e) {
          if (e.children.length) {
            _fa2(e.children);
          } else {
            delete e.children;
          }
          return e;
        });
        return list;
      };
      return _fa2(data);
    },
    handleClearClick: function handleClearClick(event) {
      event.stopPropagation();
      if (this.showCheckbox) {
        this.$refs.tree.setCheckedKeys([]);
        this.labelModel = '';
        this.valueModel = undefined;
      } else {
        this.labelModel = '';
        this.valueModel = undefined;
      }
      this.showStatus = false;
      this.$emit('selected', this.valueModel);
      this.$emit('clear');
    }
  }
};